import { Schema } from "effect";
import { HttpApiEndpoint, HttpApiError, HttpApiGroup, HttpApiSchema } from "effect/http-api";

export const CompanyVerticalsResponseSchema = Schema.Struct({
  verticals: Schema.Array(Schema.String),
  subVerticals: Schema.Array(Schema.String),
});

export const CompanyVerticalMutationResponseSchema = Schema.Struct({
  success: Schema.Boolean,
});

export const CompanyVerticalAddPayloadSchema = Schema.Union([
  Schema.Struct({
    vertical: Schema.String,
  }),
  Schema.Struct({
    subVertical: Schema.String,
  }),
]);

const orgnrParam = Schema.String;
const typeParam = Schema.String.pipe(
  Schema.refine((s): s is "vertical" | "subVertical" => s === "vertical" || s === "subVertical")
);
const valueParam = Schema.String;

export const CompanyVerticalsV3Group = HttpApiGroup.make("companyVerticalsV3")
  .add(
    HttpApiEndpoint.get("getCompanyVerticalsByCompany", "/company-verticals/:orgnr", {
      params: { orgnr: orgnrParam },
      success: CompanyVerticalsResponseSchema,
      error: [HttpApiError.BadRequestNoContent, HttpApiError.InternalServerErrorNoContent],
    })
  )
  .add(
    HttpApiEndpoint.get("getCompanyVerticalCatalog", "/company-verticals", {
      success: CompanyVerticalsResponseSchema,
      error: HttpApiError.InternalServerErrorNoContent,
    })
  )
  .add(
    HttpApiEndpoint.post("addCompanyVertical", "/company-verticals/:orgnr", {
      params: { orgnr: orgnrParam },
      payload: CompanyVerticalAddPayloadSchema,
      success: CompanyVerticalMutationResponseSchema.pipe(HttpApiSchema.status(201)),
      error: [HttpApiError.BadRequestNoContent, HttpApiError.InternalServerErrorNoContent],
    })
  )
  .add(
    HttpApiEndpoint.delete("removeCompanyVertical", "/company-verticals/:orgnr/:type/:value", {
      params: { orgnr: orgnrParam, type: typeParam, value: valueParam },
      success: HttpApiSchema.NoContent,
      error: [HttpApiError.BadRequestNoContent, HttpApiError.InternalServerErrorNoContent],
    })
  );
